import React from 'react'
import Grid from '@mui/material/Grid'
import './BuildingAndProperty.scss'
import { objectHasAnyValue } from '../../../../../resources/Utils'

const BuildingInformation = React.memo(({ buildingInformationEntity }) => {
  const buildingInformation = React.useMemo(()=>buildingInformationEntity, [buildingInformationEntity])

  const hasBuildingInformation = React.useMemo(() => {
    return objectHasAnyValue(buildingInformationEntity)
  }, [buildingInformationEntity])
  
  console.log(`hasBuildingInformation`, hasBuildingInformation)

  return (
    <>
      {hasBuildingInformation &&
      ((buildingInformation.basement && buildingInformation.basement.isChecked) ||
      (buildingInformation.businessesLocatedInTheBuilding && buildingInformation.businessesLocatedInTheBuilding.isChecked) ||
      buildingInformation.numberOfStories || 
      buildingInformation.totalSquareFootage ||
      buildingInformation.trussFloor ||
      buildingInformation.trussRoof || 
      buildingInformation.yearOfConstruction) ? (
        <h2 className="section-title">Building Information</h2>
      ) : null}

      {hasBuildingInformation &&
        buildingInformation.totalSquareFootage &&
        buildingInformation.totalSquareFootage &&
        buildingInformation.totalSquareFootage ? (
          <Grid className="section">
            <label className="main-title-label">Total square footage: {buildingInformation.totalSquareFootage ? (
              <span className="answer">{buildingInformation.totalSquareFootage}</span>
            ) : null}</label>
          </Grid>
        ) : null}

      {hasBuildingInformation &&
        buildingInformation.yearOfConstruction &&
        buildingInformation.yearOfConstruction &&
        buildingInformation.yearOfConstruction ? (
          <Grid className="section">
            <label className="main-title-label">Year of construction: {buildingInformation.yearOfConstruction ? (
              <span className="answer">{buildingInformation.yearOfConstruction}</span>
            ) : null}</label>
          </Grid>
        ) : null}

      {hasBuildingInformation &&
        buildingInformation.attachedGarage &&
        buildingInformation.attachedGarage &&
        buildingInformation.attachedGarage ? (
          <Grid className="section">
            <label className="main-title-label">Attached garage: {buildingInformation.attachedGarage ? <span className="answer">Yes</span> : ""}</label>
          </Grid>
        ) : null}

      {hasBuildingInformation &&
        buildingInformation.numberOfStories &&
        buildingInformation.numberOfStories ? (
          <Grid className="section">
            <label className="main-title-label">Number of Stories:</label>

            {(buildingInformation.numberOfStories  && 
              buildingInformation.numberOfStories.aboveGround) || 
              (buildingInformation.numberOfStories  && 
              buildingInformation.numberOfStories.belowGround) ?
              (
                <Grid className="section">
                  {buildingInformation.numberOfStories  && 
                    buildingInformation.numberOfStories.aboveGround ? (
                      <Grid>
                        <label>Above ground: {buildingInformation.numberOfStories.aboveGround}</label>
                      </Grid>
                    ) : null}

                  {buildingInformation.numberOfStories  && 
                    buildingInformation.numberOfStories.belowGround ? (
                      <Grid>
                        <label>Below ground: {buildingInformation.numberOfStories.belowGround}</label>
                      </Grid>
                    ) : null}
                </Grid>
                ) : <></>
            }
          </Grid>
        ) : null}

        {hasBuildingInformation &&
          buildingInformation.basement && 
          buildingInformation.basement.isChecked &&
          buildingInformation.basement.isChecked ? (
          <Grid className="section">
            <label className="main-title-label">Basement: {buildingInformation.basement.isChecked ? <span className="answer">Yes</span> : ""}</label>

            {buildingInformation.basement.isChecked && 
            buildingInformation.basement.walkoutBasementDoor &&
            buildingInformation.basement.walkoutBasementDoor ? (
              <Grid>
                <label>With Walkout basement door/ Bilco door</label>
              </Grid>
            ) : null}
          </Grid>
        ) : null}

        {hasBuildingInformation &&
          buildingInformation.businessesLocatedInTheBuilding && 
          buildingInformation.businessesLocatedInTheBuilding.isChecked &&
          buildingInformation.businessesLocatedInTheBuilding.isChecked ? (
          <Grid className="section">
            <label className="main-title-label">Business in building: {buildingInformation.businessesLocatedInTheBuilding.isChecked ? (
              <span className="answer">
                Yes
                {buildingInformation.businessesLocatedInTheBuilding.isChecked && 
                buildingInformation.businessesLocatedInTheBuilding.location &&
                buildingInformation.businessesLocatedInTheBuilding.location ? (
                  <>{`, ${buildingInformation.businessesLocatedInTheBuilding.location}`}</>
                ) : null}
              </span>
            ) : ""}</label>
          </Grid>
        ) : null}
        
        {hasBuildingInformation &&
        buildingInformation.trussFloor &&
        buildingInformation.trussFloor ? (
          <Grid className="section">
            <label className="main-title-label">Truss floors: {buildingInformation.trussFloor ? <span className="answer">Yes</span> : ""}</label>
          </Grid>
        ) : null}

        {hasBuildingInformation &&
        buildingInformation.trussRoof &&
        buildingInformation.trussRoof ? (
          <Grid className="section">
            <label className="main-title-label">Truss roof: {buildingInformation.trussRoof ? <span className="answer">Yes</span> : ""}</label>
          </Grid>
        ) : null}
    </>
  )
})

export default BuildingInformation